import { Box, BoxProps } from '@chakra-ui/react';
import * as React from 'react';

import { useVideoPreview } from '@/hooks/useVideoPreview';
import { ILinkPreview } from '@/modules/draft-js-link-plugin';

import { DefaultPreview } from './components/DefaultPreview';
import { RichPreview } from './components/RichPreview';
import { VideoPreview } from './components/VideoPreview';

export const PlatformContextPreviewLink: React.FC<
  {
    linkPreview: ILinkPreview | undefined;
    canEdit: boolean;
    onClose: (() => void) | undefined;
  } & BoxProps
> = ({ linkPreview, canEdit, onClose, ...boxProps }) => {
  const previewData = useVideoPreview(linkPreview?.url);

  if (!linkPreview || !onClose || !previewData || previewData.error_code) {
    return null;
  }

  switch (previewData.type) {
    case 'video':
      return (
        <Box {...boxProps}>
          <VideoPreview
            html={previewData.html}
            providerUrl={previewData.provider_url}
            href={linkPreview.url}
            target={linkPreview.targetOption}
            title={previewData.title}
            description={previewData.description}
            canEdit={canEdit}
            onCloseClick={onClose}
          />
        </Box>
      );
    case 'rich':
      return (
        <Box {...boxProps}>
          <RichPreview
            html={previewData.html}
            canEdit={canEdit}
            onCloseClick={onClose}
          />
        </Box>
      );
    default:
      return (
        <Box {...boxProps}>
          <DefaultPreview
            thumbnailUrl={previewData.thumbnail_url}
            title={previewData.title}
            providerUrl={previewData.provider_url}
            href={linkPreview.url}
            target={linkPreview.targetOption}
            description={previewData.description}
            canEdit={canEdit}
            onCloseClick={onClose}
          />
        </Box>
      );
  }
};
